import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSoftware = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M11.667 13H13M2.333 11.667V4.333a2 2 0 0 1 2-2h7.334a2 2 0 0 1 2 2v1.334m-11.334 6h-1a2 2 0 0 0 2 2H10m-7.667-2h7.334m2 2.666H13a2 2 0 0 0 2-2V7.667a2 2 0 0 0-2-2h-1.333a2 2 0 0 0-2 2v4.666a2 2 0 0 0 2 2"
	})
});
export default SvgSoftware;
